"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roleUpdate = void 0;
const create_ac_1 = require("@app/ac/util/create-ac");
const role_update_1 = require("../request/role-update");
const util_1 = require("@app/util");
const user_details_1 = require("@app/reducer/user-details");
const access_role_assign_1 = require("../request/access-role-assign");
const access_role_unassign_1 = require("../request/access-role-unassign");
const access_role_reassign_1 = require("../request/access-role-reassign");
exports.roleUpdate = (0, create_ac_1.createAC)(async (dispatch, args) => {
    const data = await (0, role_update_1.mutateRoleUpdate)({
        workspaceId: args.workspaceId,
        userId: args.userId,
        data: {
            hidden: args.roleData.hidden,
            cycleId: args.roleData.cycleId,
            cycleGroup: args.roleData.cycleGroup,
            calendarOrder: args.roleData.calendarOrder,
        },
    });
    if ((0, util_1.isUndefined)(data))
        return;
    dispatch((0, user_details_1.setRole)(data));
    if ((0, util_1.isDefined)(args.reassignAccessRole)) {
        const reassignTask = await (0, access_role_reassign_1.mutateAccessRoleReassign)({
            workspaceId: args.workspaceId,
            roles: [{
                    roleId: args.reassignAccessRole.id ?? '',
                    userId: args.userId,
                }],
        });
        console.log(reassignTask);
    }
    else {
        if ((0, util_1.isDefined)(args.unassignAccessRole)) {
            const unassignTask = await (0, access_role_unassign_1.mutateAccessRoleUnassign)({
                workspaceId: args.workspaceId,
                roles: [{
                        roleId: args.unassignAccessRole.id ?? '',
                        userId: args.userId,
                    }],
            });
            console.log(unassignTask);
        }
        if ((0, util_1.isDefined)(args.assignAccessRole)) {
            const assignTask = await (0, access_role_assign_1.mutateAccessRoleAssign)({
                workspaceId: args.workspaceId,
                roles: [{
                        roleId: args.assignAccessRole.id ?? '',
                        userId: args.userId,
                    }],
            });
            console.log(assignTask);
        }
    }
});
